import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { ReactComponent as SuperVisorLogo } from "../../assets/images/supervisorlogo.svg";
import { ReactComponent as Ronald } from "../../assets/images/Ronald.svg";
import { ReactComponent as Wade } from "../../assets/images/wade.svg";
import { CircularProgress } from "@mui/material";
import { chracterPosition, truncateMessage } from "../../utils/index";
import { colorCodesForAvatar } from "../../constants/index";
import { LIVE_CHAT_HOME_PATH } from "../../config/featureFlags";

function TeamAssignChat({ rooms, userId, isLoading }) {
  const navigate = useNavigate();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );


  const handleGoToChat = (roomId) => {
    navigate(`${LIVE_CHAT_HOME_PATH}?roomId=` + roomId);
  };

  return (
    <div className="AssignChat-Main-Container">
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress size={20} />
        </div>
      ) : (
        <>
          <div className="AssignChat-Header">
            <p className="AssignChat-text">{t.ASSIGNCHAT}</p>
            <p className="AssignChat-View">{t.VIEWCHAT}</p>
          </div>
          {rooms &&
            rooms.map((room, index) => (
              <div key={index} className="Assign-Chat-Container">
                <div className="AssignChat-Style">
                  <Avatar
                    sx={{
                      bgcolor:
                        colorCodesForAvatar[
                          chracterPosition(
                            room.roomName?.charAt(0).toUpperCase()
                          )
                        ],
                    }}
                  >
                    {!room.customer_image &&
                      room.roomName?.charAt(0).toUpperCase()}
                  </Avatar>

                  <div className="AssignName-Container">
                    <p className="AssginKatryn-Text">
                      {room.roomName || "Unknown"}
                    </p>
                    <p className="AssingKenzi-Text">
                      {truncateMessage(room.latestMessage?.content || room.latestMessageSnapshot?.content) || "No messages yet"}
                    </p>
                  </div>
                </div>
                <button
                  className="AssignChat-button"
                  type="button"
                  onClick={() => handleGoToChat(room._id)}
                >
                  Go To Chat
                </button>
              </div>
            ))}

          {(!rooms || rooms.length === 0) && (
            <div className="no-chats-message">
              <p>No active chats available</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default TeamAssignChat;
